var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative min-vh-100",attrs:{"id":"app"}},[_c('navbar'),_c('router-view',{staticClass:"container-fluid"}),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }